export const sensitiveField = () => 'inspectletIgnore'
export const sensitiveBlock = () => 'inspectlet-sensitive'
